export default {
  bind(el, binding) {
    if (binding.value.show) {
      el.classList.add("show-indicator");
    } else {
      el.classList.remove("show-indicator");
    }
    if (binding.value.rounded) {
      el.classList.add("rounded-indicator");
    } else {
      el.classList.remove("rounded-indicator");
    }
  },
  update(el, binding) {
    if (binding.value.show) {
      el.classList.add("show-indicator");
    } else {
      el.classList.remove("show-indicator");
    }
    if (binding.value.rounded) {
      el.classList.add("rounded-indicator");
    } else {
      el.classList.remove("rounded-indicator");
    }
  }
};